<!--<div tabindex="=0" class="multiselect-dropdown" (blur)="closeDropdown($event)">
  <div (click)="toggleDropdown($event)" class="btn-dropdown">
          <span class="selected-item" *ngFor="let item of selectedItems; let k = index">
        {{ item.text }}
            <a style="padding-top:2px;padding-left:2px;color:white" (click)="onItemClick($event, item)">x</a>
      </span>
    <span style="float:right !important;padding-right:4px">
             <fa-icon [icon]="getDropdownIcon()"></fa-icon>
            </span>
  </div>
  <div class="list-dropdown" [hidden]="!_settings?.open">
    <ul class="list-item">
      <li *ngFor="let item of _rawData; trackBy: trackByFn; let i = index;" (click)="onItemClick($event, item)" class="multiselect-item-checkbox">
&lt;!&ndash;        <input type="checkbox" aria-label="multiselect-item" (change)="isSelected(item)" [disabled]="item?.isDisabled"/>&ndash;&gt;
&lt;!&ndash;        <input type='text' style='border: none;' readonly size='1' value='&#x2753;' />&ndash;&gt;
        <input style="border: none;" type="text" readonly size="1" [value]="getVal(item)" />
        <div>
          {{ item.text }}
        </div>
      </li>
    </ul>
  </div>
</div>-->

<div ngbDropdown autoClose="outside" class="d-inline-flex px-1">

  <ng-container *ngIf="selectedItems.length > 0">
    <div class="tw-flex btn tw-mr-1" [ngClass]="resolveColor(item)"
         *ngFor="let item of selectedItems; let k = index"
         [@popup]
    >

      <a ngbTooltip="{{'lang.globals.toggle' | translate}}" container="body" placement="top"
         [ngClass]="resolveColor(item)" class="tw-mr-3"
            (click)="onItemClick($event, item)"
      >
      <!--            <fa-icon [icon]="resolveIcon(item)"></fa-icon>-->
      {{item.text | translate}}
      <sb-icon *ngIf="item.value === 1" icon="toggleOn"></sb-icon>
      <sb-icon *ngIf="item.value !== 1" icon="toggleOff"></sb-icon>
      </a>
      <a (click)="removeItem(item)" class="border-dashed-left flex-grow-0 white tw-pl-3 icon-in-btn">
        <sb-icon icon="cancel"></sb-icon>
      </a>
    </div>
  </ng-container>

  <ng-container *ngIf="selectedItems.length === 0">
    {{placeholder ? placeholder : ''}}
  </ng-container>
  <button class="btn btn-hover-primary" ngbDropdownToggle>
    <sb-icon class="mr-2" icon="toggleOn"></sb-icon>
    <sb-icon class="d-none d-md-inline-flex" style="" icon="chevronDown"></sb-icon>
  </button>

  <div ngbDropdownMenu>
    <ul class="dropdown">
      <ng-container *ngIf="headline">
        <li class="head"> {{headline}}</li>
        <li class="separator"></li>
      </ng-container>
      <li [ngClass]="resolveColor(item)" *ngFor="let item of _data; let i = index;"
          class="item d-flex justify-content-between align-items-center">
        <a (click)="onItemClick($event, item)" class="flex-grow-1 item-link" [ngClass]="resolveColor(item)">
          <sb-icon *ngIf="item.value === 0" class="mr-2" icon="toggleOff"></sb-icon>
          <sb-icon *ngIf="item.value === -1" class="mr-2 icon-in-btn" icon="circle"></sb-icon>
          <sb-icon *ngIf="item.value === 1" class="mr-2" icon="toggleOn"></sb-icon>
          {{item.text|translate}}
        </a>
        <a (click)="isItemSelected(item) ? removeItem(item) : null"
           [ngClass]="{'disabled' : !isItemSelected(item),'white' : item.value >= 0}"
           class="item-link border-dashed-left flex-grow-0" style="padding: 0.7rem 1rem;">
          <sb-icon icon="cancel"></sb-icon>
        </a>
      </li>
    </ul>
  </div>
</div>
